import { Drawer, useMediaQuery, useTheme } from '@mui/material';
import SidebarContent, { DRAWER_WIDTH } from './SidebarContent';

export default function ResponsiveSidebar({ mobileOpen, onClose }) {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Drawer
      variant={desktop ? 'permanent' : 'temporary'}
      open={desktop || mobileOpen}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={{ width: desktop ? DRAWER_WIDTH : 0, flexShrink: 0, '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' } }}
    >
      <SidebarContent onNavigate={onClose} />
    </Drawer>
  );
}
